import { createContent } from '@altify/utils';

export const content = createContent({
  en: {
    weekly: 'Weekly',
    monthly: 'Monthly',
    confirmSchedule: 'Confirm Schedule',
    firstPurchaseToday: 'Do you want to make your first purchase today?',
  },
  de: {
    weekly: 'Wöchentlich',
    monthly: 'Monatlich',
    confirmSchedule: 'Zeitplan bestätigen',
    firstPurchaseToday: 'Willst du heute deinen ersten Kauf tätigen?',
  },
});
